import { Table, Modal, Button } from "antd";
import { useState } from "react";

interface Merchant {
  key: number;
  maDaiLy: string;
  tenDaiLy: string;
  loaiHinh: string;
  trangThai: string;
}
export const MerchantScreen = () => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<Merchant | null>(null);

  const columns = [
    {
      title: "Số thứ tự",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Mã đại lý",
      dataIndex: "maDaiLy",
      key: "maDaiLy",
    },
    {
      title: "Tên đại lý",
      dataIndex: "tenDaiLy",
      key: "tenDaiLy",
    },
    {
      title: "Loại hình",
      dataIndex: "loaiHinh",
      key: "loaiHinh",
    },
    {
      title: "Trạng thái",
      dataIndex: "trangThai",
      key: "trangThai",
    },
  ];

  const dataSource: Merchant[] = [
    {
      key: 1,
      maDaiLy: "DL001",
      tenDaiLy: "Đại lý A",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 2,
      maDaiLy: "DL002",
      tenDaiLy: "Đại lý B",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Tạm ngừng",
    },
    {
      key: 3,
      maDaiLy: "DL003",
      tenDaiLy: "Đại lý C",
      loaiHinh: "Doanh nghiệp tư nhân",
      trangThai: "Hoạt động",
    },
    {
      key: 4,
      maDaiLy: "DL004",
      tenDaiLy: "Đại lý D",
      loaiHinh: "Hộ kinh doanh",
      trangThai: "Chờ duyệt",
    },
    {
      key: 5,
      maDaiLy: "DL005",
      tenDaiLy: "Đại lý E",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 6,
      maDaiLy: "DL006",
      tenDaiLy: "Đại lý F",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Đã dừng",
    },
    {
      key: 7,
      maDaiLy: "DL001",
      tenDaiLy: "Đại lý A",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 8,
      maDaiLy: "DL002",
      tenDaiLy: "Đại lý B",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Tạm ngừng",
    },
    {
      key: 9,
      maDaiLy: "DL003",
      tenDaiLy: "Đại lý C",
      loaiHinh: "Doanh nghiệp tư nhân",
      trangThai: "Hoạt động",
    },
    {
      key: 10,
      maDaiLy: "DL004",
      tenDaiLy: "Đại lý D",
      loaiHinh: "Hộ kinh doanh",
      trangThai: "Chờ duyệt",
    },
    {
      key: 11,
      maDaiLy: "DL005",
      tenDaiLy: "Đại lý E",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 12,
      maDaiLy: "DL006",
      tenDaiLy: "Đại lý F",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Đã dừng",
    },
    {
      key: 13,
      maDaiLy: "DL001",
      tenDaiLy: "Đại lý A",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 14,
      maDaiLy: "DL002",
      tenDaiLy: "Đại lý B",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Tạm ngừng",
    },
    {
      key: 15,
      maDaiLy: "DL003",
      tenDaiLy: "Đại lý C",
      loaiHinh: "Doanh nghiệp tư nhân",
      trangThai: "Hoạt động",
    },
    {
      key: 16,
      maDaiLy: "DL004",
      tenDaiLy: "Đại lý D",
      loaiHinh: "Hộ kinh doanh",
      trangThai: "Chờ duyệt",
    },
    {
      key: 17,
      maDaiLy: "DL005",
      tenDaiLy: "Đại lý E",
      loaiHinh: "Công ty TNHH",
      trangThai: "Hoạt động",
    },
    {
      key: 18,
      maDaiLy: "DL006",
      tenDaiLy: "Đại lý F",
      loaiHinh: "Công ty Cổ phần",
      trangThai: "Đã dừng",
    },
  ];

  const handleRowClick = (record: Merchant) => {
    setSelectedRow(record);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setSelectedRow(null);
  };
  // Function to close the modal
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedRow(null);
  };

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 10 }}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        rowKey="key"
      />
      <Modal
        title="Thông tin đại lý"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            OK
          </Button>,
          <Button key="back" onClick={handleCancel}>
            Đóng
          </Button>,
        ]}
      >
        {selectedRow && (
          <div>
            <p>
              <strong>Mã đại lý:</strong> {selectedRow.maDaiLy}
            </p>
            <p>
              <strong>Tên đại lý:</strong> {selectedRow.tenDaiLy}
            </p>
            <p>
              <strong>Loại hình:</strong> {selectedRow.loaiHinh}
            </p>
            <p>
              <strong>Trạng thái:</strong> {selectedRow.trangThai}
            </p>
          </div>
        )}
      </Modal>
    </div>
  );
};
